export default {
  form: {
    ClientInfo: {
      values: {
        firstName: 'František',
        lastName: 'Slanina',
        phoneNumber: '608728589',
        email: 'franta@slanina.cz',
        consentInstantMessaging: false,
        consentToOfferMarketing: false,
        consentCommUnsecured: true,
      },
    },
    ClientAddress: {
      values: {
        permanentAddress: {
          city: 'Praha 6',
          houseNumber: '73B',
          landRegistryNumber: '695',
          street: 'Evropská',
          zip: '16000',
        },
        contactAddress: {
          city: 'Praha 6',
          houseNumber: '73',
          landRegistryNumber: '695',
          street: 'Evropská',
          zip: '16000',
        },
        differentContactAddress: false,
      },
    },
    ClientDetails: {
      values: {
        identityCardNumber: '202704555',
        identityCardExpiration: '7.1.2024',
        personalIdentificationNumber: '771215/1238',
        maritalStatus: '1',
        citizenship: '52',
        placeOfBirth: 'Praha',
        countryOfBirth: '52',
      },
    },
    FinanceProfession: {
      values: {
        employmentTypeCode: '1',
        professionCode: '8',
      },
    },
    FinanceEmployer: {
      values: {
        employerAddress: {
          city: 'Praha',
          houseNumber: '9',
          landRegistryNumber: '722',
          street: 'U Hostavického potoka',
          zip: '19800',
        },
        employerName: 'Moneta Investment, s.r.o.',
        employerId: '24227625',
        employedSince: '10.10.2017',
        employedTo: '03.08.2054',
        trialPeriod: false,
        noticePeriod: false,
      },
    },
    FinanceIncome: {
      values: {
        net3MonthIncome: 50000,
        net3MonthHouseholdIncome: 50000,
        taxCrOnlyFlag: true,
      },
    },
    FinanceExpenses: {
      values: {
        numberOfDependents: 0,
        otherCostOfLiving: 0,
        otherMonthlyInstallments: 0,
        housingExpenditure: 0,
      },
    },
    ClientAdditionalInfo: {
      values: {
        education: '4',
        stayOnAddressDuration: '5_10',
        livingType: '1',
        maritalStatus: '1',
        otherDocumentType: 'DRIVING_LICENSE',
        pep: 'NO',
      },
    },
    LoanPreConfigurator: {
      values: {
        loanAmount: 20000,
        loanAmountSlider: 20000,
        term: 30,
        termSlider: 30,
        instalmentDay: 15,
      },
    },
    RecapitulationFooter: {
      values: {
        smsCode: '0609',
      },
    },
  },
  client: {
    employmentTypeCode: undefined,
  },
}
